/**
 * Sanitizes a filename into a Supabase Storage-safe key segment.
 * Supabase rejects object keys containing non-ASCII characters (InvalidKey),
 * so accents are folded to their base letter (Loïc -> Loic) before stripping
 * anything outside the accepted charset. Spaces are kept (Supabase allows them).
 */
export const sanitizeStorageFileName = (name: string): string => {
    const safe = name
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^0-9a-zA-Z!\-_.*'() ]/g, "")
        .trim();
    // A fully non-Latin name (e.g. 履歴書.pdf) can sanitize down to just ".pdf" or "";
    // fall back to a generic base name so the key stays valid and keeps its extension.
    return safe && !safe.startsWith(".") ? safe : `file${safe}`;
};
